import { apiSlice } from '../api/apiSlice';
import {
    CartResponse,
    AddToCartRequest,
    ApplyPromoCodeRequest,
    PrepareCheckoutRequest,
    PrepareCheckoutResponse,
    RemoveFromCartRequest,
    TopupOptionsRequest,
    TopupOptionsResponse,
    AddTopupRequest,
    UpdateTopupItemRequest,
    UpdateCartRequest,
} from './cart.types';

export const cartApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCart: builder.query<CartResponse, void>({
            query: () => ({
                url: '/cart',
                method: 'GET',
            }),
            providesTags: [{ type: 'Cart' }],
            keepUnusedDataFor: 0,
        }),
        addToCart: builder.mutation<CartResponse, AddToCartRequest>({
            query: (body) => ({
                url: '/cart/add',
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Cart' }],
        }),
        updateCart: builder.mutation<CartResponse, UpdateCartRequest>({
            query: (body) => ({
                url: '/cart/update',
                method: 'PATCH',
                body,
            }),
            invalidatesTags: [{ type: 'Cart' }],
        }),
        updateTopupItem: builder.mutation<CartResponse, UpdateTopupItemRequest>(
            {
                query: (body) => ({
                    url: '/cart/update-topup-item',
                    method: 'PATCH',
                    body,
                }),
                invalidatesTags: [{ type: 'Cart' }],
            }
        ),
        applyDiscount: builder.mutation<CartResponse, ApplyPromoCodeRequest>({
            query: (body) => ({
                url: '/cart/apply-discount',
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Cart' }],
        }),
        prepareCheckout: builder.mutation<
            PrepareCheckoutResponse,
            PrepareCheckoutRequest
        >({
            query: (body) => ({
                url: '/cart/prepare-checkout',
                method: 'POST',
                body,
            }),
        }),
        getTopupOptions: builder.mutation<
            TopupOptionsResponse,
            TopupOptionsRequest
        >({
            query: (body) => ({
                url: '/cart/top-up-options',
                method: 'POST',
                body,
            }),
        }),
        addTopup: builder.mutation<CartResponse, AddTopupRequest>({
            query: (body) => ({
                url: '/cart/add-top-up',
                method: 'POST',
                body,
            }),
        }),
        clearCart: builder.mutation<void, void>({
            query: () => ({
                url: '/cart/clear',
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Cart' }],
        }),
        removeFromCart: builder.mutation<CartResponse, RemoveFromCartRequest>({
            query: (body) => ({
                url: '/cart/remove',
                method: 'DELETE',
                body,
            }),
            invalidatesTags: [{ type: 'Cart' }],
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetCartQuery,
    useLazyGetCartQuery,
    useAddToCartMutation,
    useUpdateCartMutation,
    useUpdateTopupItemMutation,
    useApplyDiscountMutation,
    usePrepareCheckoutMutation,
    useGetTopupOptionsMutation,
    useAddTopupMutation,
    useClearCartMutation,
    useRemoveFromCartMutation,
} = cartApiSlice;
